import { LOADER_START, LOADER_STOP } from "../constants/LoaderConstants";

const initialState = {
  loader: false,
};

export const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_START:
      return {
        loader: true,
      };

    case LOADER_STOP:
      return {
        ...state,
        loader: false,
      };

    default:
      return state;
  }
};
